import { useState } from 'react';
import axios from "@fetch/axios"
import { useTranslation } from '@hooks/useTranslation';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const ProductoAgotadoBox = ({ product, isModalOpen, setIsModalOpen }) => {
    const [email, setEmail] = useState(null)
    const productId = product.id
    const { translate } = useTranslation();
    const MySwal = withReactContent(Swal)

    const enviar = async () => {
        if (!email) {
            MySwal.fire({
                text: translate('error.field'),
                icon: 'error',
                title: 'Oops...'
            })
            return;
        }

        try {
            const res = await axios.post(
                "/stock-alerts/create",
                {
                    "email": email,
                    "product_id": productId,
                }
            );
            if (res.data.errors) {
                MySwal.fire({
                    text: res.data.message,
                    icon: 'error',
                    title: 'Oops...'
                })
            } else {
                setIsModalOpen(false);
                setEmail('')
                MySwal.fire({
                    text: translate('login.resend'),
                    icon: 'success',
                })
            }
        } catch (error) {
            MySwal.fire({
                text: error.response.data,
                icon: 'error',
                title: 'Oops...'
            })
        }
    }

    return (
        isModalOpen && (
            <div className='ProductoAgotado'>
                <div>
                    <i className='icon-Closed' onClick={() => setIsModalOpen(false)}></i>
                    <h4>{translate('product.no_stock')}.</h4>
                    <p>
                        {translate('product.no_stock_layer')}
                    </p>
                    <div className='FormInput'>
                        <input placeholder={translate('view.myprofile.email')} onChange={(e) => { setEmail(e.target.value) }} value={email} />
                    </div>
                    <div
                        onClick={() => { enviar() }}
                        className='ButtonDarkMedium'
                    >
                        <i className='icon-Bell' ></i>
                        {translate('product.store')}
                    </div>
                </div>
            </div>
        )
    );
};

export default ProductoAgotadoBox;
